export default function GS_Formatting() {
  return (
    <div className="p-4">
      <h1>GS Formatting</h1>
    </div>
  );
}
